<template>
    <div>
        <div class="title"><span></span><h1>EXCEl设置流量阈值(仅限流量共享)</h1></div>
        <el-form>
            <el-form-item class="btnArea">
                <span>
                    <a class="export-tamplate" href="javascript:void(0);" @click="getLimitDataList()">刷新</a>
                </span> 
                <el-upload ref="upload"  style="display: inline-block; margin-left: 10px;" :show-file-list="false" 
                :action="uploadUrl('sim/import/excel/update/flowdata')" :headers="setHeader()" 
                :limit="1" :data="updateFlowdataFields" :on-success = "handleSuccess">
                    <el-button slot="trigger" plain>导入Excel</el-button>
                </el-upload> 
                <span>
                    <a class="export-tamplate" href="javascript:void(0);" @click="exportSimData()">下载模板</a>
                </span> 
            </el-form-item>
             <div class="title"><span></span><h1>按条件修改阀值(仅限流量共享，已激活的卡)</h1></div>
            <el-form-item label="卡类型：" width="80"> 
                <el-select v-model="searchForm.cardCategory" clearable>
                    <el-option value="MP" label="MP" ></el-option>
                    <el-option value="MS" label="MS" ></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="流量池：">
                <el-select v-model="searchForm.simPoolId" filterable placeholder="请选择或输入关键字" clearable>
                    <el-option v-for="item in flowPoolOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属代理商：">
                <el-select v-model="searchForm.agentId" filterable placeholder="请选择或输入关键字" clearable>
                    <el-option v-for="item in agentsOption" :value="item.agentId" :key="item.agentId" :label="item.agentName"></el-option>
                </el-select>
            </el-form-item>
              <el-form-item label="阀值/MB：" prop="voiceGroupId">
                        <el-col :span="3">
                            <el-input v-model="searchForm.totalFlow"></el-input>
                        </el-col>
                </el-form-item>
              <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAdminCardListHandler">按搜索条件批量修改</el-button>
            </el-form-item>
        </el-form>


        <el-table :data="tbpg.tableData" border >
            <el-table-column type="index" label="序号" ></el-table-column>
            <el-table-column prop="into_no" label="接入号" ></el-table-column>
            <el-table-column prop="sim_data" label="阈值（ M ）" ></el-table-column>
            <el-table-column label="处理结果" >
                <template v-slot="scope">
                    {{scope.row.state==0?'失败':scope.row.state==1?'成功':'未知状态'}}
                </template> 
            </el-table-column>
            <el-table-column prop="dispose_user" label="处理人" ></el-table-column>
            <el-table-column label="处理时间" >
                <template v-slot="scope">
                    {{dateFormat('yyyy-MM-dd hh:mm:ss', new Date(scope.row.create_time))}}
                </template> 
            </el-table-column>
            <el-table-column prop="remark" label="备注" ></el-table-column>
            
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  

    </div>
</template>
<script>
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            importFields:{},
            updateFlowdataFields:{},

            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            searchForm:{
                cardCategory:'',
                simPoolId:'',
                agentId:'',
                totalFlow:''
            },
            flowPoolOption: [],//运营商名称列表
            agentsOption: [],
        }
    },
    methods: {
        
        handleSuccess(res){
            if(res.code == 200){
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
                this.getLimitDataList();
            }else{
                this.$refs.upload.clearFiles();
                this.$message.error(res.message);
            }
        },

        exportSimData(){//导出excel文件
            this.exportExcel('/excel/update/sim/data', {});

            this.$message.success('下载中……');
        },

        getLimitDataList(){
            common.sysRequest('sim/limit/data/list', {}, 'post').then(res => {
                if(res.data.code == 200){
                    common.listCallback(this, res, 'tbpg');
                }
            })
        },
        getAdminCardListHandler(){
            var data={
                cardCategory:this.searchForm.cardCategory,
                simPoolId:this.searchForm.simPoolId,
                agentId:this.searchForm.agentId,
                totalFlow:this.searchForm.totalFlow
            }
            common.sysRequest('sim/batch/limit/data/list', data, 'post').then(res => {
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                }else{
                     this.$message.error(res.data.message);
                }
                
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getLimitDataList();
            
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getLimitDataList();
            
        },
         //获取流量池
        getFlowPool(){
            common.sysRequest('simPool/list', {agentId: null}, 'post').then(res => {
                if(res.data.code == 200){
                    for(let key in res.data.data){
                        this.flowPoolOption.push({id: key, name:res.data.data[key]})
                    }
                }else{
                    this.$message.error(res.data.message);
                }             
            })   
        }
    },
    created () {
         this.getFlowPool();
        common.sysRequest('/agent/listOption', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.agentsOption = res.data.data;
            }

        });
        this.getLimitDataList();
    },

    computed: {
        
    },

    watch:{

    }
}
</script>


<style lang="scss" scoped>

    .title{
        height: 32px;
        line-height: 32px;
        margin-bottom: 10px;

        span{
            display: inline-block;
            height: 22px;
            width: 5px;
            margin-right: 5px;
            background: #2196f3;
            vertical-align: bottom;
        }
        h1{
            display: inline-block;
            height: 18px;
            line-height: 16px;
            font-size: 14px;
            font-weight: bold;
            width: 300px;
            vertical-align: bottom;
        }
    }
    .export-tamplate{
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        width: 85px;
        height: 32px;
        display: inline-block;
        text-align: center;
        vertical-align: bottom;
        margin-left: 10px;
        font-size: 13px;
        color: #606266;
    }

    .export-tamplate:hover{
        color: #409EFF;
        border-color: #409EFF;
        transition: .3s;
    }
</style>